// Turns a failed assignments request into accurate user-facing text. Graham sends
// {detail: {code, message}} for refusals; anything else is a service failure.
export type RoleSaveFailure = 'conflict' | 'forbidden' | 'invalid' | 'missing' | 'service'

export function classifyRoleError(error: unknown): { kind: RoleSaveFailure; message: string } {
 const response = (error as { response?: { status?: number; data?: { detail?: { message?: string } | string } } })?.response
 const status = response?.status
 const detail = response?.data?.detail
 const serverMessage = typeof detail === 'object' && detail?.message ? detail.message : undefined
 if (status === 409) return { kind: 'conflict', message: 'A teammate changed this role first. The latest assignments are shown; choose again to replace them.' }
 if (status === 403) return { kind: 'forbidden', message: 'You no longer have access to change assignments for this organization. Nothing was saved.' }
 if (status === 404) return { kind: 'missing', message: 'This organization is no longer available. Nothing was saved.' }
 if (status === 422) return { kind: 'invalid', message: `${serverMessage || 'That assignment is not valid.'} Nothing was saved.` }
 return { kind: 'service', message: 'Could not save because the service did not respond. Nothing was saved; try again.' }
}
